import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { playerLobbyKey, selectPlayerSession, recordPlayerActivity, PLAYER_IDLE_EVENT } from '../services/playerLobbySession';

// Lives above routes: reading another section is activity too, not an idle Home.
export default function PlayerSessionLifecycle() {
  const { user, loading } = useAuth();
  const key = playerLobbyKey(user);
  useEffect(() => {
    if (loading) return undefined;
    selectPlayerSession(key);
    if (!key) return undefined;
    const activity = () => {
      if (document.visibilityState === 'hidden') return;
      if (recordPlayerActivity()) window.dispatchEvent(new Event(PLAYER_IDLE_EVENT));
    };
    activity();
    const events = ['pointerdown', 'keydown', 'scroll', 'focus', 'pageshow'];
    events.forEach(name => window.addEventListener(name, activity, { passive: true, capture: true }));
    document.addEventListener('visibilitychange', activity);
    return () => {
      events.forEach(name => window.removeEventListener(name, activity, true));
      document.removeEventListener('visibilitychange', activity);
    };
  }, [key, loading]);
  return null;
}
